/** @module csi/notification/ToolbarNewTasks */
define([
	"dojo/_base/declare",
	"csi/html",
	"csi/main",
	"csi/notification/DropdownWrapper",
	"csi/state/rootStore",
	"csi/service/notificationService",
	"csi/view/ToolbarDropDown",
	"csi/xml",
	"csi/xml/Writer"
], function(declare, html, csi, {DropdownWrapper}, {watchStoreProperty, routerStore, sessionStore}, {LAST_CHECKED_NOTIFICATION_ATTR_ID}, ToolbarDropDown, xml, Writer) {

	return declare(ToolbarDropDown, {
		/** @property {number} taskCount */
		taskCount: 0,

		badgeNode: null,

		/** {boolean} _publishing - indicates whether or not updating the read time */
		_publishing: null,

		buildRendering: function() {
			this.inherited(arguments);

			this.badgeNode = html.create("span", {
				"class": "csi-badge"
			}, this.domNode);
		},

		postCreate: function() {
			this.inherited(arguments);

			this.set("taskCount", sessionStore.notificationCount);

			this.own(watchStoreProperty(sessionStore, "_notificationCount", (name, oldValue, newValue) => {
				this.set("taskCount", newValue);
			}));
		},
		/**
		 * Map taskCount property to DOM
		 * @param {number} value
		 */
		_setTaskCountAttr: function(value) {
			const {badgeNode} = this;
			let badgeText;

			if (value >= 10) {
				badgeText = "9+";
			} else if (value > 0) {
				badgeText = String(value);
			} else {
				badgeText = "";
			}

			html.clear(badgeNode);
			html.text(badgeNode, badgeText);
			html.setVisible(badgeNode, !!badgeText);

			this._set("taskCount", value);
		},

		/**
		 * @override
		 * Return 'false' to load drop-down every time
		 */
		isLoaded: function() {
			return false;
		},

		/**
		 * @override
		 * Create a drop-down
		 */
		loadDropDown: function(callback) {
			const cache = this.getView().cacheView;
			this.updateReadTime();

			routerStore.setBodyComponent(DropdownWrapper, {
				cache, 
				elem: this.domNode, 
			});
		},


		/**
		 * @override
		 * Do nothing. The click action will be handled in '_onDropDownMouseUp'.
		 * This is a workaround for https://centric8.atlassian.net/browse/C8-21189.
		 * The 'click' is usually fired when the mouse button is pressed and then released over the element
		 * (see https://developer.mozilla.org/en-US/docs/Web/API/Element/click_event).
		 * In our case, if the mouse button is pressed over the bottom part of our icon button,
		 * the mouse button gets released over a drop-down menu which captures 'mouseup' event.
		 * Our widget never gets 'mouseup' event and never generates 'click' event because of that.
		 * '_onDropDownMouseUp', on other hand, is wired to 'document.mouseup' (aka touch.release) event and
		 * will always be called (see dijit/_HasDropDown.js)
		 */
		onClick: function() {
		},

		/** update the read time of notification */
		async updateReadTime() {
			// if previous request doesn't finish yet, just return to avoid the potential conflict
			if (this._publishing) {
				return;
			}

			const writer = new Writer();
			const currentTime = csi.getCurrentTime();

			// use 'publishAttribute' because some initial users (like Administrator) do not have this attribute in object model
			writer
			.changeNode(sessionStore.userDetailsUrl)
			.publishAttribute(LAST_CHECKED_NOTIFICATION_ATTR_ID, xml.ATTR_TIME, currentTime);

			try {
				this._publishing = true;
				await writer.execute();
				
				// set the last check time on the cached node
				sessionStore.userDetails[LAST_CHECKED_NOTIFICATION_ATTR_ID] = currentTime;
			} catch(ex) {
				// don't block the application, just log the error
				console.error(ex);
			} finally {
				this._publishing = false;
			}
		},
	});
});